/* K for Kaia — always-visible scroll progress cue for horizontal card rows (D&R pattern).
   Injects a track+thumb under each target row; thumb width = visible fraction,
   position tracks scrollLeft. Survives async loads (recommendations) and re-renders. */
(function () {
  var SELECTORS = [
    '.f-complementary-products .f-complementary-products__slide'
  ];

  function bind(row) {
    if (row.dataset.kfkCue) return;
    row.dataset.kfkCue = '1';
    var cue = document.createElement('div');
    cue.className = 'kfk-scrollcue';
    cue.innerHTML = '<div class="kfk-scrollcue__thumb"></div>';
    row.insertAdjacentElement('afterend', cue);
    var thumb = cue.firstElementChild;

    function update() {
      var max = row.scrollWidth - row.clientWidth;
      if (max < 8) { cue.style.display = 'none'; return; }
      cue.style.display = 'block';
      var frac = row.clientWidth / row.scrollWidth;
      thumb.style.width = (frac * 100) + '%';
      thumb.style.transform = 'translateX(' + (row.scrollLeft / max) * (100 / frac - 100) + '%)';
    }
    row.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
    setTimeout(update, 600);
  }

  function scan() {
    SELECTORS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(bind);
    });
  }
  document.addEventListener('DOMContentLoaded', scan);
  document.addEventListener('recommendations:loaded', function () { setTimeout(scan, 100); });
  scan();
  setTimeout(scan, 1500);
  setTimeout(scan, 4000);
})();
